import Adaptative from '@/features/home/adaptative';
import Advantage from '@/features/home/advantage';
import Clients from '@/features/home/clients';
import Features from '@/features/home/features';
import Hero from '@/features/home/hero';
import Infos from '@/features/home/infos';
import Pricing from '@/features/home/pricing';
import Testimonials from '@/features/home/testimonials';
import { VideoWidget } from '@/features/home/video-widget';
import { SEOProps } from '@/components/ui/SEO';
import { basePath } from '@/utils/basePath';
import { SOFTWARE_APPLICATION_SCHEMA } from '@/utils/schema';
import { Fragment } from 'react';

const HOME_SEO: SEOProps = {
  title: 'zLawyer — Logiciel de gestion et facturation pour avocats',
  description:
    "zLawyer accompagne les cabinets d'avocats depuis 2006 : facturation électronique, gestion clients, reporting. Simple, intuitif, conforme Factur-X.",
  url: `https://www.zlawyer.fr${basePath}/`,
  keywords:
    'logiciel avocat, logiciel cabinet avocat, facturation avocat, gestion cabinet avocat, facturation électronique avocat, logiciel comptabilité avocat',
  schema: SOFTWARE_APPLICATION_SCHEMA,
};

export default function Page() {
  return (
    <Fragment>
      <Hero />
      <Advantage />
      <Adaptative />
      <Features />
      <Infos />
      <Testimonials />
      <Clients />
      <Pricing />
      <VideoWidget />
    </Fragment>
  );
}

Page.seo = HOME_SEO;
